import * as Sentry from '@sentry/vue'

export function useErrorReporting() {
    const captureError = (error, context = {}) => {
        const { tags = {}, extra = {}, level = 'error' } = context

        Sentry.withScope((scope) => {
            if (tags) {
                Object.entries(tags).forEach(([key, value]) => {
                    scope.setTag(key, value)
                })
            }

            if (extra) {
                Object.entries(extra).forEach(([key, value]) => {
                    scope.setExtra(key, value)
                })
            }

            scope.setLevel(level)

            Sentry.captureException(error)
        })
    }

    const captureMessage = (message, context = {}) => {
        const { tags = {}, extra = {}, level = 'info' } = context

        Sentry.withScope((scope) => {
            if (tags) {
                Object.entries(tags).forEach(([key, value]) => {
                    scope.setTag(key, value)
                })
            }

            if (extra) {
                Object.entries(extra).forEach(([key, value]) => {
                    scope.setExtra(key, value)
                })
            }

            scope.setLevel(level)

            Sentry.captureMessage(message)
        })
    }

    const setUserContext = (user) => {
        Sentry.setUser(user)
    }

    const setContext = (name, context) => {
        Sentry.setContext(name, context)
    }

    const addBreadcrumb = (breadcrumb) => {
        Sentry.addBreadcrumb(breadcrumb)
    }

    return {
        captureError,
        captureMessage,
        setUserContext,
        setContext,
        addBreadcrumb,
    }
}
